import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import usePageTitle from "@/lib/usePageTitle";

export default function PasswordReset() {
  usePageTitle("Passwort zurücksetzen");
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!token) setErr("Ungültiger oder fehlender Token. Bitte fordern Sie einen neuen Reset-Link an.");
  }, [token]);

  const submit = async (ev) => {
    ev.preventDefault();
    setErr(null);
    if (pw.length < 8) { setErr("Passwort mind. 8 Zeichen"); return; }
    if (pw !== pw2) { setErr("Passwörter stimmen nicht überein"); return; }
    setBusy(true);
    try {
      await api.post("/auth/password-reset-confirm", { token, new_password: pw });
      setDone(true);
      setTimeout(() => navigate("/login"), 1500);
    } catch (e) {
      const d = e.response?.data?.detail;
      setErr(typeof d === "string" ? d : (d?.msg || e.message));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center px-6" data-testid="password-reset-page">
      <div className="w-full max-w-md bg-white rounded-2xl border border-black/5 shadow-xl p-8">
        <Link to="/" className="text-xs text-zinc-500 hover:text-zinc-900 uppercase tracking-widest">← Zurück</Link>
        <h1 className="font-heading text-3xl font-bold tracking-tight mt-3 mb-1">Neues Passwort setzen</h1>
        <p className="text-sm text-zinc-500 mb-6">Wählen Sie ein neues Passwort für Ihr Tonneva-Konto.</p>

        {done ? (
          <div className="p-4 rounded-lg bg-emerald-50 text-emerald-800 text-sm" data-testid="password-reset-success">
            Passwort erfolgreich geändert — Sie werden zur Anmeldung weitergeleitet …
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <div>
              <Label className="text-xs">Neues Passwort</Label>
              <Input type="password" className="h-11 rounded-md" value={pw} onChange={(e) => setPw(e.target.value)} minLength={8} required data-testid="password-reset-new" />
              <p className="text-xs text-zinc-400 mt-1">mind. 8 Zeichen</p>
            </div>
            <div>
              <Label className="text-xs">Passwort bestätigen</Label>
              <Input type="password" className="h-11 rounded-md" value={pw2} onChange={(e) => setPw2(e.target.value)} minLength={8} required data-testid="password-reset-confirm" />
            </div>
            {err && <div className="text-sm text-red-600 bg-red-50 rounded-md p-2.5" data-testid="password-reset-error">{err}</div>}
            <Button type="submit" disabled={busy || !token} className="w-full text-white rounded-full h-11" style={{ background: "linear-gradient(135deg, #3FA64E 0%, #2A86A8 100%)" }} data-testid="password-reset-submit">
              {busy ? "…" : "Passwort speichern"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
